// Small per-user display preferences kept on this device (a minimized dock, a finished checklist). They live under
// «zofino.pref.<userId>.» so they survive signing out (storage.clear keeps this prefix) and stay separate when several
// people use the same browser. Storage can be blocked (private mode); then everything simply works without memory.

export const PREF_PREFIX = "zofino.pref.";

const keyOf = (userId, name) => `${PREF_PREFIX}${userId || "anon"}.${name}`;

export function readPref(userId, name) {
    try {
        return window.localStorage.getItem(keyOf(userId, name)) === "1";
    } catch (error) {
        return false;
    }
}

export function writePref(userId, name, value) {
    try {
        if (value) window.localStorage.setItem(keyOf(userId, name), "1");
        else window.localStorage.removeItem(keyOf(userId, name));
    } catch (error) {
        // not remembered on this device
    }
}

// keys a sign-out must not erase
export const isKeptOnSignOut = (key) => String(key || "").startsWith(PREF_PREFIX);
